import React, { useState } from 'react';

const ExpenseForm = () => {
  const [expenseItems, setExpenseItems] = useState([
    { description: 'Breakfast', amount: 20, image: null },
    { description: 'Lunch', amount: 45, image: null },
  ]);
  const [newItem, setNewItem] = useState({ description: '', amount: '', image: null });
  const [total, setTotal] = useState(65);
  const [note, setNote] = useState('');

  const handleItemChange = (index, field, value) => {
    const items = [...expenseItems];
    items[index][field] = value;
    setExpenseItems(items);
    updateTotal(items);
  };

  const handleImageChange = (index, file) => {
    const items = [...expenseItems];
    items[index].image = file;
    setExpenseItems(items);
  };

  const handleNewItemChange = (field, value) => {
    setNewItem({ ...newItem, [field]: value });
  };

  const handleNewItemImageChange = (file) => {
    setNewItem({ ...newItem, image: file });
  };

  const addItem = () => {
    if (newItem.description && newItem.amount) {
      const items = [...expenseItems, newItem];
      setExpenseItems(items);
      setNewItem({ description: '', amount: '', image: null });
      updateTotal(items);
    }
  };

  const removeItem = (index) => {
    const items = expenseItems.filter((_, i) => i !== index);
    setExpenseItems(items);
    updateTotal(items);
  };

  const updateTotal = (items) => {
    const totalAmount = items.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
    setTotal(totalAmount);
  };

  const handleNoteChange = (event) => {
    setNote(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle the form submission, including sending the image files
    console.log('Form submitted:', { expenseItems, total, note });
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div>
          <label>
            Expense Type:
            <input type="text" value="Transfera" readOnly />
          </label>
        </div>
        <div>
          <label>
            Kilometric:
            <input type="checkbox" checked readOnly />
          </label>
          <label>
            Forfeit:
            <input type="checkbox" checked readOnly />
          </label>
          <label>
            Analytical:
            <input type="checkbox" checked readOnly />
          </label>
        </div>
        <div>
          <label>
            Date Range:
            <input type="text" value="21/08/2024 - 23/08/2024" readOnly />
          </label>
          <label>
            Km:
            <input type="number" value="200" readOnly />
          </label>
        </div>
        <div>
          <h4>Expense Items</h4>
          {expenseItems.map((item, index) => (
            <div key={index}>
              <input
                type="text"
                value={item.description}
                onChange={(e) => handleItemChange(index, 'description', e.target.value)}
              />
              <input
                type="number"
                value={item.amount}
                onChange={(e) => handleItemChange(index, 'amount', e.target.value)}
              />
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleImageChange(index, e.target.files[0])}
              />
              <button type="button" onClick={() => removeItem(index)}>X</button>
            </div>
          ))}
        </div>
        <div>
          <h4>Add New Item</h4>
          <input
            type="text"
            placeholder="Description"
            value={newItem.description}
            onChange={(e) => handleNewItemChange('description', e.target.value)}
          />
          <input
            type="number"
            placeholder="Amount"
            value={newItem.amount}
            onChange={(e) => handleNewItemChange('amount', e.target.value)}
          />
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleNewItemImageChange(e.target.files[0])}
          />
          <button type="button" onClick={addItem}>Add</button>
        </div>
        <div>
          <h4>Total: €{total.toFixed(2)}</h4>
        </div>
        <div>
          <label>
            Note:
            <textarea value={note} onChange={handleNoteChange}></textarea>
          </label>
        </div>
        <div>
          <button type="button">Cancel</button>
          <button type="submit">Confirm</button>
        </div>
      </form>
    </div>
  );
};

export default ExpenseForm;
